/**
 * feedbackBadges.js
 *
 * Configuration for feedback badges/medals available when giving peer feedback.
 *
 * Each badge has:
 *   id          - unique string identifier (stored in DB)
 *   name        - display name
 *   description - short description shown in UI
 *   icon        - emoji or relative path to an image asset (e.g. '/icons/leadership.png')
 *                 If the value starts with '/', it is treated as an image path.
 *                 Otherwise it is rendered as an emoji/text.
 *
 * Add, remove or edit badges here without touching the component or backend logic.
 */

const FEEDBACK_BADGES = [
  {
    id: 'leadership',
    name: 'Leadership',
    description: 'Guides others positively and takes initiative.',
    icon: '/assets/learning-thumbnails/leadership.png',
  },
  {
    id: 'teamwork',
    name: 'Teamwork',
    description: 'Collaborates well and supports coworkers.',
    icon: '/assets/learning-thumbnails/teamwork.png',
  },
  {
    id: 'problem_solving',
    name: 'Problem Solving',
    description: 'Finds solutions and handles challenges effectively.',
    icon: '/assets/learning-thumbnails/problem_solving.png',
  },
  {
    id: 'innovation',
    name: 'Innovation',
    description: 'Brings new ideas or improves processes.',
    icon: '/assets/learning-thumbnails/innovation.png',
  },
  {
    id: 'communication',
    name: 'Communication',
    description: 'Communicates clearly and respectfully.',
    icon: '/assets/learning-thumbnails/communication.png',
  },
  {
    id: 'customer_focus',
    name: 'Customer Focus',
    description: 'Delivers excellent service or client support.',
    icon: '/assets/learning-thumbnails/customer_focus.png',
  },
  {
    id: 'positive_attitude',
    name: 'Positive Attitude',
    description: 'Maintains professionalism and morale.',
    icon: '/assets/learning-thumbnails/positive_attitude.png',
  },
];

export default FEEDBACK_BADGES;
